module.exports = __webpack_public_path__ + "static/media/RemoveFromCart.8775bfbf.svg";